import { useState } from 'react';
import { Trash } from 'lucide-react';
import type { UserProfile } from '~/types';
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogTrigger,
  AlertDialogDescription,
} from '~/components/ui/alert-dialog';
import { Button } from '~/components/ui/button';

interface Props {
  profile: UserProfile;
  onProfileDelete: (profile: UserProfile) => void;
}

export default function ButtonDeleteProfile({
  profile,
  onProfileDelete,
}: Props) {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <AlertDialog open={isOpen} onOpenChange={setIsOpen}>
      <AlertDialogTrigger>
        <Button variant="destructive">
          <Trash size={16} /> Remove
        </Button>
      </AlertDialogTrigger>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>
            Are you sure you want to delete {profile.firstName}
            &apos;s profile?
          </AlertDialogTitle>
          <AlertDialogDescription>
            This will delete this profile and any registrations they have.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel>Cancel</AlertDialogCancel>
          <AlertDialogAction
            onClick={() => {
              onProfileDelete(profile);
              setIsOpen(false);
            }}
          >
            Continue
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
